import { Controller } from "stimulus"

export default class extends Controller {
  static targets = ["canBeSkippedAmount", "subQuestion", "requiredCheckBox"]

  toggleRequirement(event) {
    this.changeAmount(event.target.checked, this.subQuestionTargets.length)
  }

  addQuestion() {
    this.changeAmount(this.requiredCheckBoxTarget.checked, this.subQuestionTargets.length + 1)
  }

  removeQuestion() {
    this.changeAmount(this.requiredCheckBoxTarget.checked, this.subQuestionTargets.length - 1)
  }

  changeAmount(checked, amount) {
    this.canBeSkippedAmountTarget.innerHTML = ` ${checked ? amount : 0}`
  }

  toggleSectionQuestionList(event) {
    const sectionQuestionsList = event.target.closest('.inline-form').querySelector('.section-questions-list');
    if (sectionQuestionsList) {
      if (event.target.checked) {
        sectionQuestionsList.classList.add('d-none');
      } else {
        sectionQuestionsList.classList.remove('d-none');
      }
    }
  }
}
